export default __webpack_public_path__ + "static/media/down.12fb0a67.svg";